import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=beb0de5a&scoped=true&"
import script from "./BookingStatus.vue?vue&type=script&lang=js&"
export * from "./BookingStatus.vue?vue&type=script&lang=js&"
import style0 from "./BookingStatus.vue?vue&type=style&index=0&id=beb0de5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb0de5a",
  null
  
)

export default component.exports